import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { Animated } from '../Animated';
import { Route } from './Router';

function NavigatorScreen(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'NavigatorScreen'),
      _useContextSystem$ani = _useContextSystem.animationEnterDelay,
      animationEnterDelay = _useContextSystem$ani === void 0 ? 0 : _useContextSystem$ani,
      _useContextSystem$ani2 = _useContextSystem.animationEnterDuration,
      animationEnterDuration = _useContextSystem$ani2 === void 0 ? 0.14 : _useContextSystem$ani2,
      _useContextSystem$ani3 = _useContextSystem.animationExitDelay,
      animationExitDelay = _useContextSystem$ani3 === void 0 ? 0 : _useContextSystem$ani3,
      _useContextSystem$ani4 = _useContextSystem.animationExitDuration,
      animationExitDuration = _useContextSystem$ani4 === void 0 ? 0.14 : _useContextSystem$ani4,
      children = _useContextSystem.children,
      component = _useContextSystem.component,
      path = _useContextSystem.path,
      _render = _useContextSystem.render,
      otherProps = _objectWithoutProperties(_useContextSystem, ["animationEnterDelay", "animationEnterDuration", "animationExitDelay", "animationExitDuration", "children", "component", "path", "render"]);

  return /*#__PURE__*/React.createElement(Route, Object.assign({}, otherProps, {
    path: path,
    ref: forwardedRef,
    render: function render(routeProps) {
      var _history$location, _history$location$sta;

      var history = routeProps.history;
      var isBack = (history == null ? void 0 : history.action) === 'POP' || (history == null ? void 0 : (_history$location = history.location) == null ? void 0 : (_history$location$sta = _history$location.state) == null ? void 0 : _history$location$sta.isBack);

      var combinedProps = _objectSpread(_objectSpread({}, routeProps), otherProps);

      var content = children ? typeof children === 'function' ? children(combinedProps) : children : component ? /*#__PURE__*/React.createElement(component, combinedProps) : _render ? _render(combinedProps) : null;
      var initial = {
        opacity: 0,
        x: isBack ? -50 : 50
      };
      var exit = {
        delay: animationExitDelay,
        opacity: 0,
        x: isBack ? 50 : -50,
        transition: {
          duration: animationExitDuration,
          ease: 'easeInOut'
        }
      };
      return /*#__PURE__*/React.createElement(Animated, Object.assign({}, {
        animate: {
          opacity: 1,
          transition: {
            delay: animationEnterDelay,
            duration: animationEnterDuration,
            ease: 'easeInOut'
          },
          x: 0
        },
        exit: exit,
        initial: initial
      }, {
        key: path
      }), content);
    }
  }));
}

export default contextConnect(NavigatorScreen, 'NavigatorScreen');